import type { ScreenInteractionContext } from './platform/analytics/interactionAnalytics'
import { trackPhonePressed } from './platform/analytics/interactionAnalytics'
import parsePhoneNumber, { isValidPhoneNumber } from 'libphonenumber-js'

type Props = {
  phone: string
  variant?: 'compact' | 'standard'
  analytics?: ScreenInteractionContext
}

function formatDisplayPhone(raw: string): string {
  const trimmed = raw.trim()
  if (isValidPhoneNumber(trimmed)) {
    const parsed = parsePhoneNumber(trimmed)
    if (parsed) return parsed.formatNational()
  }
  return trimmed
}

function telHref(raw: string): string {
  const tel = raw.trim().replace(/\s+/g, '')
  return tel.startsWith('tel:') ? tel : `tel:${tel}`
}

/** Mobile ReportAnEmergencyScreen parity: compact call button (not full-width banner). */
export function ReportEmergencyCallButton({
  phone,
  variant = 'compact',
  analytics,
}: Props) {
  const display = formatDisplayPhone(phone)
  const className =
    variant === 'standard' ? 'emergency-dial-btn' : 'report-emergency-call-btn'
  return (
    <a
      className={className}
      href={telHref(phone)}
      onClick={analytics ? () => trackPhonePressed({ ...analytics, phone }) : undefined}
    >
      {display}
    </a>
  )
}
